import { useServices } from './useServices';

export const useValidationService = () => {
  return useServices().validation;
};
